<template>
  <div class="page">
    <div class="m-bg-cover"></div>
    <m-line-to class="m-line" :isType="isType" :obj="obj"/>
    <!--支付信息-->
    <m-pay-info v-if="isType==1" :obj="obj" class="m-pay"/>
    <!--审核意见-->
    <m-idea-info v-if="isType==2||isType==3" :obj="obj" class="m-pay"/>
    <!--退款信息-->
    <m-refund-info :isType="isType" :obj="obj" @apply="apply" class="m-refund"/>
    <!--按钮-->
    <div class="x-flex-between m-box">
      <van-button block class="m-btn-default" @click="goTo()">返回</van-button>
      <van-button v-if="isType==3" block class="x-btn-log m-btn-next" @click="goTo('/refundApply')">重新申请</van-button>
    </div>               
  </div>
</template>

<script>
  import mLineTo from './components/m-line-to'
  import mPayInfo from './components/m-pay-info'
  import mRefundInfo from './components/m-refund-info'
  import mIdeaInfo from './components/m-idea-info'
  import { Dialog } from 'vant';
  export default {
    components: {mLineTo,mPayInfo,mRefundInfo,mIdeaInfo,[Dialog.Component.name]: Dialog.Component,},
    data () {
      return {
        isType: 1,
        obj:{}
      }
    },
    created () {
      this.getRefundInfo()
    },
    methods: {
      goTo(i){
        if(i){
          this.$router.replace({
            path:i,
            query:{
              detailId:this.$route.query.detailId  
            }
          })
        } else {
          this.$router.go(-1)
        }
      },
      getRefundInfo () {
        if (!this.$route.query.detailId) {
          return
        }
        this.http.getRequest({
          url: `app/exam/queryRefundInfo/${this.$route.query.detailId}`,
          msg: {},
          success: (res) => {
            this.obj = res.data
            if(res.data.refundStatus==1){
              this.isType = 2
            } else if(res.data.refundStatus==2||res.data.refundStatus==3||res.data.examineStatus==2){
              this.isType = 3
            } else {
              this.isType = 1
            }
          }
        })
      },
      apply(){
        Dialog.confirm({
          title: '撤销申请',
          message: '确认撤销后，如需问题可在有效期内重新申请。',
        }).then(() => {
          this.http.postRequest({
            url:`app/exam/removeRefundSubmit/${this.obj.refundId}`,
            msg:{},
            success:(res)=>{
              this.utils.toastSuccess('撤销成功')
              this.$router.go(-1)
            }
          },true)
        }).catch(() => {
         
        });
      }
    },
    mounted () {

    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style ref="stylesheet/less" lang="less" scoped>
  @import "~@/assets/css/variable.less";
  .page{
    background: #F4F6F9;
    .m-bg-cover {
      position: absolute;
      width: 100%;
      height: 180px;
      background: linear-gradient(360deg, #F4F6F9 0%, #2B6CF9 28%, #2B6CF9 100%);
      z-index: -1;
    }
    .m-line{
      margin-top: 38px;
    }
    .m-pay{
      margin: 55px 12px 0 12px;
    }
    .m-refund{
      margin: 11px 12px 0 12px;
    }
    .m-box{
      margin: 40px 20px 25px 20px;
      gap:20px;
      justify-content: center;
      .m-btn-default,.m-btn-next{
        width: 144px;
      }
      .m-btn-default{
        border-radius: 8px;
        background: #ffffff;
        color: #2B6CF9;
      }
    }
  }
</style>

